module.exports = __webpack_public_path__ + "static/media/sg.e43dc414.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sg.png
// module id = 1976
// module chunks = 0